import styled from '@emotion/styled';

export const StyledSubmitDate = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;

    button {
        width: 100%;
        border-radius: 0;
    }
`;

export const StyledCalendar = styled.div`
    height: 100%;
    .DateRangePicker {
        box-shadow: ${(props) => props.theme.boxShadow.modalInput};
        border: ${(props) => `solid 1px ${props.theme.shades.lightGrey}`};

        &_picker {
            width: calc(100% + 24px);
            border: 0;
            box-shadow: none;
            top: 65px !important;
            overflow: auto;
            margin-left: -12px;
            margin-right: -12px;
            left: 0 !important;
        }
    }
    .DayPicker {
        &__withBorder {
            box-shadow: none;
        }
        &_transitionContainer {
            &__vertical {
                overflow: unset;
            }
        }
    }
    .CalendarDay {
        &__selected {
            &_start {
                &:before,
                &:after {
                    left: 33px;
                }
            }
            &_end {
                &:before,
                &:after {
                    right: 33px;
                }
            }
            &_start,
            &_end {
                &:before,
                &:after {
                    border-width: 22px;
                    margin-top: -23px;
                }
            }
        }
    }
    .DayPickerNavigation {
        display: none;
    }
    .CalendarMonth {
        &_caption {
            padding-bottom: 0;
        }
    }
    .CalendarMonthGrid {
        & > div:nth-child(2) {
            .CalendarMonth_caption {
                padding-bottom: 37px;
            }
        }
        & > div:not(:nth-child(1)) {
            border-bottom: ${(props) => `1px solid ${props.theme.colors.separator}`};
            padding-bottom: 1em;
        }
    }
    .DateInput {
        &_input {
            height: 50px;
            padding-left: 32px;
        }
    }
`;
